import { customIcons } from "./icon-components/custom-icons";
import { materialSymbolsIcons } from "./icon-components/materialSymbols-icons";
const iconLibrary = Object.assign(Object.assign({}, materialSymbolsIcons), customIcons);
export default iconLibrary;
